const initialState = {
  isDataLoaded: false,
  isDocsLoaded: false,
  extendedInfos: {},
  isLoading: false,
};

export const initChest = (payload) => ({
  type: "INIT_CHEST",
  payload,
});

export const setIsLoading = (payload) => ({
  type: "IS_LOADING",
  payload,
});
export const populateChestDocuments = (payload) => ({
  type: "POPULATE_CHEST_DOCUMENTS",
  payload,
});

export const updateFiles = (payload) => ({
  type: "UPDATE_FILES",
  payload,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case "INIT_CHEST":
      return action.payload;
    case "IS_LOADING":
      return { ...state, isLoading: action.payload };
    case "UPDATE_FILES":
      return { ...state, files: action.payload };
    default:
      return state;
  }
}
